export default __webpack_public_path__ + "static/media/charging.5479747f.png";